import { useState } from "react";
import { Languages } from "lucide-react";
import { t, getLang } from "@/i18n";

export const LANG_NAMES: Record<string, string> = { en: "English", es: "Spanish", zh: "Chinese", fr: "French" };
export const langName = (c: string) => {
  const n = LANG_NAMES[c] ? t(LANG_NAMES[c]) : c?.toUpperCase();
  return ["es", "fr"].includes(getLang()) ? n.toLowerCase() : n;
};

export const pick = (q: any, field: string, original: boolean) =>
  (!original && q?.view?.fields?.[field]?.text) || q?.[field];

export const translatedFrom = (q: any) => {
  const f = q?.view?.fields || {};
  const first: any = Object.values(f)[0];
  return first ? first.from : null;
};

export function useOriginal() {
  const [ids, setIds] = useState<string[]>([]);
  return { isOriginal: (id: string) => ids.includes(id), toggle: (id: string) => setIds((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id])) };
}

export function TranslateToggle({ q, original, onToggle }: { q: any; original: boolean; onToggle: () => void }) {
  const from = translatedFrom(q);
  if (!from) return null;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs faint" title={t("Translations are for accessibility; original text remains available.")} data-testid={`translate-label-${q.id}`}>
      <Languages size={12} />
      {t(original ? "Original in {lang}" : "Translated from {lang}", { lang: langName(from) })}
      <button className="text-[var(--accent-primary)] font-semibold hover:underline" onClick={onToggle} data-testid={`translate-toggle-${q.id}`}>
        {t(original ? "View translated" : "View original")}
      </button>
    </span>
  );
}
